<div class="atn-ds-chart-js-chart">
  <canvas [id]="id"></canvas>
</div>
